/*
 * Copyright (c) 2020  Apricad LLC. All Rights Reserved.
 */

import { dlgTitle, studyDlg, titleText } from "./studyPageStyle";

export const studyNotesStyle = (theme) => {
  const notesColor = theme.palette.notes.main;

  return {
    dlgTitle,
    studyDlg,
    titleText,

    contentMain: {
      "& > :not(:last-child)": {
        borderBottom: `2px solid ${theme.palette.secondary.main}`,
      },
      padding: "0 1rem",
    },

    contentTitle: {
      color: "white",
      backgroundColor: notesColor,
    },

    lecLabel: {
      display: "flex",
      flexDirection: "column",
      margin: "1rem 0",
    },

    lecTitle: {
      fontSize: "1.5rem",
      margin: "0.25rem 0",
    },

    lecActions: {
      display: "flex",
      justifyContent: "flex-end",
      padding: "0.5rem",
    },

    notesDiv: {
      "& > :not(:last-child)": {
        borderBottom: `2px solid ${theme.palette.notes.light}`,
        marginBottom: "0.75rem",
      },
    },

    notesButton: {
      backgroundColor: notesColor,
      color: "white",
      "&:hover": { background: theme.palette.notes.dark },
      marginRight: "0.5rem",
      textTransform: "none",
    },
  };
};
